import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, filter, map, Observable, of, tap } from 'rxjs';
import { IResponseContent } from '../models/interfaces/responseContent.interface';
import {IHoursOptions,IOperatorsOptions,IServicesOptions, IStructureOptions} from '../models/interfaces/typology.interface';
import { IRequestSaveReservation, IResponseSaveReservation } from '../models/interfaces/reservations.interface';

@Injectable({
  providedIn: 'root',
})
export class MyReservationService {

  operators :IOperatorsOptions[] = [];
  private _httpClient: HttpClient = inject(HttpClient);


  getTypologyServicesByStructure(establishmentId: number): Observable<IServicesOptions[]> {
    return this._httpClient.get<IResponseContent<IServicesOptions[]>>(`/booking/service/get-of/${establishmentId}`).pipe(
     map(({ content }) => content));
  }
  

  //servizio che restituisce una lista di operatori attraverso una struttura
getOperatorsByStructure(establishmentId: number, serviceId?: number): Observable<IOperatorsOptions[]> {
  return this._httpClient.get<IResponseContent<IOperatorsOptions[]>>(`/booking/operator/by-establishment/${establishmentId}`).pipe(
    map(({ content }) => 
      serviceId != null ? content.filter(op => Array.isArray(op.serviceIds) && op.serviceIds.includes(serviceId)) : content
    )
  );
}


  //servizio che restituisce tutti i servizi dato un operatore specifico
  getTypologyServiceByOperators(operatorId: number): Observable<IServicesOptions[]> {
    return this._httpClient.get<IResponseContent<IServicesOptions[]>>(`/booking/service/get-of-operator/${operatorId}`).pipe(
      map(({ content }) => content));
  }
  

  //servizio che restituisce tutte le strutture attraverso un servizio
  getTypologyStructureByServices(serviceId: number): Observable<IStructureOptions[]> {
    return this._httpClient.get<IResponseContent<IStructureOptions[]>>(`/booking/establishment/by-serviceId/${serviceId}`).pipe(
      map(({ content }) => content));
  }

  //servizio che restituisce una lista di orari attraverso: un id struttura , un id servizio  , un id operatore e una data
  getTypologyHours(establishmentId:number, serviceId:number, date:string, operatorId?:number): Observable<IHoursOptions[]> {
    let params: HttpParams = new HttpParams();    
    // .set('',); //quelli obbligatori
    if (!!establishmentId) params = params.set('establishmentId', establishmentId);
    if (!!serviceId) params = params.set('serviceId', serviceId);
    if (!!date) params = params.set('date', date);
    if (!!operatorId) params = params.set('operatorId', operatorId);
    return this._httpClient.get<IResponseContent<IHoursOptions[]>>('/booking/slot/available', { params }).pipe(
      map(({ content }) => content));
  }

  saveReservation(body:IRequestSaveReservation):Observable<IResponseSaveReservation>{
    return this._httpClient.post<IResponseContent<IResponseSaveReservation>>('/booking/reservation',body).pipe(
      map(({ content}) => content)
    )
  }
}
